/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigniusVerificationMethodsDto
 */
export interface SigniusVerificationMethodsDto {
    /**
     * Available verification method identifiers (e.g. NECT, IDNOW_AUTO, IDNOW_VIDEO)
     * @type {Array<string>}
     * @memberof SigniusVerificationMethodsDto
     */
    methods: Array<string>;
}

/**
 * Check if a given object implements the SigniusVerificationMethodsDto interface.
 */
export function instanceOfSigniusVerificationMethodsDto(value: object): value is SigniusVerificationMethodsDto {
    if (!('methods' in value) || value['methods'] === undefined) return false;
    return true;
}

export function SigniusVerificationMethodsDtoFromJSON(json: any): SigniusVerificationMethodsDto {
    return SigniusVerificationMethodsDtoFromJSONTyped(json, false);
}

export function SigniusVerificationMethodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigniusVerificationMethodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'methods': json['methods'],
    };
}

export function SigniusVerificationMethodsDtoToJSON(json: any): SigniusVerificationMethodsDto {
    return SigniusVerificationMethodsDtoToJSONTyped(json, false);
}

export function SigniusVerificationMethodsDtoToJSONTyped(value?: SigniusVerificationMethodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'methods': value['methods'],
    };
}

